/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { TTicketingModalRootTypes, useTicketingModalRootStore } from './ticketing-modal-root.store';
import CreateSpaceModal from '../../../spaces/space/components/modals/create-space-modal/create-space-modal';
import DeleteSpaceModal from '../../../spaces/space/components/modals/delete-space-modal/delete-space-modal';
import ShareSpaceModal from '../../../spaces/space/components/modals/share-space-modal/share-space-modal';
import UpdateSpaceModal from '../../../spaces/space/components/modals/update-space-modal';
import CreateLabelTicketModal from '../../../label-ticketing/components/modals/create-label-ticket-modal/create-label-ticket-modal';
import UpdateLabelTicketModal from '../../../label-ticketing/components/modals/update-label-ticket-modal/update-label-ticket-modal';
import DeleteLabelTicketModal from '../../../label-ticketing/components/modals/delete-label-ticket-modal/delete-label-ticket-modal';
import UpdateTicketModal from '../../../tickets/ticket/components/modals/update-ticket-modal/update-ticket-modal';
import CreateTicketModal from '../../../tickets/ticket/components/modals/create-ticket-modal/create-ticket-modal';
import CreateBulkTicketModal from '../../../tickets/ticket/components/modals/create-bulk-ticket-modal/create-bulk-ticket-modal';
import DeleteTicketModal from '../../../tickets/ticket/components/modals/delete-ticket-modal/delete-ticket-modal';
import CreateColumnModal from '../../../columns/column/components/create-column-modal/create-column-modal';
import UpdateColumnModal from '../../../columns/column/components/update-column-modal/update-column-modal';
import DeleteColumnModal from '../../../columns/column/components/delete-column-modal/delete-column-modal';
import FilterTicketModal from '../../../tickets/ticket/components/modals/filter-ticket-modal/filter-ticket-modal';
import DuplicateTicketModal from '../../../tickets/ticket/components/modals/duplicate-ticket-modal/duplicate-ticket-modal';
import CompleteTicketModal from '../../../tickets/ticket/components/modals/complete-ticket-modal/complete-ticket-modal';
import ArchiveTicketModal from '../../../tickets/ticket/components/modals/archive-ticket-modal/archive-ticket-modal';
import { ArchiveAllTicketModal } from '../../../tickets/ticket/components/modals/archive-all-ticket-modal';
import RestoreTicketModal from '../../../tickets/ticket/components/modals/restore-ticket-modal/restore-ticket-modal';
import { RestoreAllTicketModal } from '../../../tickets/ticket/components/modals/restore-all-ticket-modal';
import DeleteSpaceMemberModal from '../../../spaces/space-member/components/modals/delete-space-member/delete-space-member';
import DeleteUserTicketingModal from '../../../ticketing-user/components/delete-ticketing-user-modal/delete-ticketing-user-modal';
import SetAsAdminTicketingUserModal from '../../../ticketing-user/components/set-as-admin-ticketing-user-modal/set-as-admin-ticketing-user-modal';
import DeleteInvitationTicketingUserModal from '../../../ticketing-user/components/delete-invitation-ticketing-user-modal/delete-invitation-ticketing-user-modal';
import InvitationTicketingUserModal from '../../../ticketing-user/components/list-invitation-ticketing-user-modal/list-invitation-ticketing-user-modal';
import ResendInvitationTicketingUserModal from '../../../ticketing-user/components/resend-invitation-ticketing-user-modal/resend-invitation-ticketing-user-modal';
import InviteAsAdminTicketingUserModal from '../../../ticketing-user/components/invite-as-admin-ticketing-user-modal/invite-as-admin-ticketing-user-modal';

const modalMap: Partial<Record<TTicketingModalRootTypes, React.ComponentType<any>>> = {
  // Space Modal
  CreateSpaceModal,
  DeleteSpaceModal,
  ShareSpaceModal,
  UpdateSpaceModal,

  // Label Ticket Modal
  CreateLabelTicketModal,
  UpdateLabelTicketModal,
  DeleteLabelTicketModal,

  // Ticket Modal
  UpdateTicketModal,
  CreateTicketModal,
  CreateBulkTicketModal,
  DeleteTicketModal,
  FilterTicketModal,
  DuplicateTicketModal,
  CompleteTicketModal,
  ArchiveTicketModal,
  ArchiveAllTicketModal,
  RestoreTicketModal,
  RestoreAllTicketModal,

  // Column Modal
  CreateColumnModal,
  UpdateColumnModal,
  DeleteColumnModal,

  // Space Member Modal
  DeleteSpaceMemberModal,

  // Ticketing User Modal
  DeleteUserTicketingModal,
  SetAsAdminTicketingUserModal,
  DeleteInvitationTicketingUserModal,
  InvitationTicketingUserModal,
  ResendInvitationTicketingUserModal,
  InviteAsAdminTicketingUserModal,
};

const TicketingModalRootRefactor = memo(() => {
  // HOOKS
  const { modals } = useTicketingModalRootStore();

  // RENDER
  return (
    <>
      {modals.map(({ type, props }, idx) => {
        const ModalComponent = modalMap[type];

        if (!ModalComponent) return null;

        return <ModalComponent key={idx} {...props} />;
      })}
    </>
  );
});
TicketingModalRootRefactor.displayName = 'TicketingModalRootRefactor';

export default TicketingModalRootRefactor;
